import { Inject, Injectable, Optional } from '@angular/core';
import { DS_LOG_CONFIG, LogConfig } from '@anecdotes/design-system/injection-tokens';

export interface ILoggerService {
  log(log: any): void;
  error(err: Error): void;
}

@Injectable()
export class LoggerService implements ILoggerService {
  constructor(@Optional() @Inject(DS_LOG_CONFIG) private logConfig: LogConfig) {}
  log(log: any): void {
    if (this.logConfig?.useLogging) {
      /* eslint-disable no-console */
      console.log(log);
    }
  }

  error(err: Error): void {
    if (this.logConfig?.useLogging) {
      /* eslint-disable no-console */
      console.error(err);
    }
  }
}
